import { uniq, uniqBy } from 'lodash';
import { StubsService } from './../../../Services/stubs.service';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'automation-data',
    templateUrl: './automation-data.component.html',
    styleUrls: ['./automation-data.component.css']
})
export class AutomationComponent implements OnInit {

    @Input()
    public service = null;

    public identifiersData: any[] = [];

    public defaultStubsStatus: any[] = [];

    public respCodes: string[] = [];

    public showData: boolean = false;

    constructor(private subsService: StubsService) { }

    public ngOnInit() {

        const calls = [];

        this.subsService.getServiceByName(this.service._id)
            .subscribe(serviceData => {
                this.service = serviceData;
                this.respCodes = this.service.serviceTemplates.map((template) => template.code);

                calls.push(
                    this.subsService.getIdentifiersFromSpecName(this.service._id),
                    this.subsService.getDefaultStubsStatus(this.service._id)
                );

                Observable
                    .forkJoin(calls)
                    .subscribe((data: any[]) => {

                        this.identifiersData = data[0];

                        if (this.identifiersData.length) {

                            this.identifiersData = uniqBy(this.identifiersData, 'specName');
                        }

                        this.defaultStubsStatus = data[1];

                        this.handleAllResponseCodes();

                        this.showData = true;
                    }, (error) => {

                        this.showData = true;

                        alert(error);
                    });
            });
    }

    handleAllResponseCodes() {

        let allResponseCode = this.service.serviceTemplates.map((template) => template.code);

        allResponseCode = uniq(allResponseCode);

        allResponseCode.forEach((respCode) => {

            const detectedStub = this.defaultStubsStatus.find((defaultStubStatus) => defaultStubStatus.respCode === respCode);

            if (!detectedStub) {

                this.defaultStubsStatus.push({
                    stubName: 'AUTOMATED || DEFAULT_STUB',
                    respCode: respCode,
                    status: 'NOT DETECTED'
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/components/automation-data/automation-data.component.ts